{
    "glossaries": {
        "list": {
            "language": "Language",
            "new": "New glossary",
            "title": "Title",
            "words": "Words"
        },
        "view": {
            "hint": "Each line represents a separate glossary term. Entries may include full sentences.",
            "language": "Language",
            "tab_description": {
                "block": "Blocked terms are filtered out of the transcription output. Use this for profanity, filler words, or any terms you never want to appear in the transcript.",
                "boost": "Boosting is applied to proper names, brand names, technical terms, or uncommon words to give them higher priority during transcription, improving accuracy for rare, ambiguous, or context-specific terms.",
                "replace": "Replace terms allow you to define corrections for commonly misheard or misspelled words. Each line specifies a term that should be replaced in the final transcript."
            },
            "tab_placeholder": {
                "block": "Enter terms to block, one per line...",
                "boost": "Enter terms to boost, one per line...",
                "replace": "Enter replacement terms, one per line..."
            },
            "title": "Title"
        }
    }
}
